// Opções fixas do campo "Área relacionada" (multi-seleção temática do projeto).
// Compartilhado entre os formulários de criação/edição (comum e admin).
export const RELATED_AREA_OPTIONS = [
  { value: "Educação", label: "Educação" },
  { value: "Esporte", label: "Esporte" },
  { value: "Tecnologia", label: "Tecnologia" },
  { value: "Saúde", label: "Saúde" },
  { value: "Cultura", label: "Cultura" },
  { value: "Empregabilidade", label: "Empregabilidade" },
  { value: "Outros", label: "Outros" },
];

// Mapeia o array de strings salvo no projeto para as opções do Select.
export const relatedAreasToOptions = (areas) =>
  RELATED_AREA_OPTIONS.filter((option) => (areas || []).includes(option.value));

// Compromissos ODS (Objetivos de Desenvolvimento Sustentável). O valor é o
// identificador salvo em projects.project_commitments (ex.: "NoPoverty").
export const ODS_OPTIONS = [
  { value: "NoPoverty", label: "Erradicação da pobreza" },
  { value: "ZeroHunger", label: "Fome zero" },
  { value: "GoodHealth", label: "Saúde e bem-estar" },
  { value: "QualityEducation", label: "Educação de qualidade" },
  { value: "GenderEquality", label: "Igualdade de gênero" },
  { value: "CleanWater", label: "Água limpa e saneamento" },
  { value: "CleanEnergy", label: "Energia limpa e acessível" },
  { value: "DecentWork", label: "Trabalho decente e crescimento econômico" },
  { value: "Industry", label: "Indústria, inovação e infraestrutura" },
  { value: "ReducedInequalities", label: "Redução das desigualdades" },
  { value: "SustainableCities", label: "Cidades e comunidades sustentáveis" },
  { value: "ResponsibleConsumption", label: "Consumo e produção responsáveis" },
  { value: "ClimateAction", label: "Ação contra a mudança global do clima" },
  { value: "LifeBelowWater", label: "Vida na água" },
  { value: "LifeOnLand", label: "Vida terrestre" },
  { value: "PeaceJustice", label: "Paz, justiça e instituições eficazes" },
  { value: "Partnership", label: "Parcerias e meios de implementação" },
];
